import { ColumnDef } from '@tanstack/react-table';
import axios from 'axios';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { errorHandler } from 'helpers/response-utils';
import { useState } from 'react';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import UpdateGoals from './UpdateGoals';
import moment from 'moment';
import { log } from 'console';

// interface GoalsTableProps {
//   onShowProgress: (goalId: number) => void;
// }

export const getGoalsTableColumns = (
  type: 'weight' | 'hba1c'
): ColumnDef<any>[] => [
  {
    accessorKey: 'current_date',
    header: () => {
      return (
        <div className="d-inline-flex flex-center m-2">
          <span>Start Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { current_date } = original;
      return <>{moment(current_date).format('DD-MM-YYYY')}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className:
          'ps-4 border-start border-end border-translucent ps-0 text-capitalize'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'current_value',
    header: type === 'weight' ? 'Start Weight (Kg)' : 'Start HbA1C (%)',
    cell: ({ row: { original } }) => {
      const { current_value } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            {' '}
            {current_value
              ? type === 'weight'
                ? `${current_value} Kg`
                : `${current_value}%`
              : null}{' '}
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className:
          'ps-4 border-start border-end border-translucent ps-0 text-capitalize'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'target_date',
    header: () => {
      return (
        <div className="d-inline-flex flex-center m-2">
          <span>Targeted Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { target_date } = original;
      return <>{moment(target_date).format('DD-MM-YYYY')}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className:
          'ps-4 border-start border-end border-translucent ps-0 text-capitalize'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'target_value',
    header: type === 'weight' ? 'Targeted Weight (Kg)' : 'Targeted HbA1C (%)',
    cell: ({ row: { original } }) => {
      const { target_value } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            {' '}
            {target_value
              ? type === 'weight'
                ? `${target_value} Kg`
                : `${target_value}%`
              : null}{' '}
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className:
          'ps-4 border-start border-end border-translucent ps-0 text-capitalize'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    id: 'leadDropdown',
    cell: ({ row: { original }, table }: any) => {
      const token = localStorage.getItem('token');
      const { onShowProgress } = table.options.meta;

      const deleteReacod = async (id: number) => {
        const response = await axios.delete(
          `${process.env.REACT_APP_ENDPOINT}/clinic/patient/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (response.data['status'] == false) {
          errorHandler(response.data);
          return false;
        }
        handleClose();
      };

      const [show, setShow] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);

      const handleClose = () => setShow(false);

      const handleCloseEditModal = (value: any) => {
        setShowEditModal(false);
      };

      const handleShow = () => setShow(true);
      const handleShowEditModal = () => setShowEditModal(true);

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <Dropdown.Item onClick={() => onShowProgress(original.id)}>
                View Progress
              </Dropdown.Item>
              <Dropdown.Item onClick={handleShowEditModal}>Edit</Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>

          <Modal
            show={showEditModal}
            onHide={() => handleCloseEditModal(false)}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Edit Goal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <UpdateGoals
                handleCloseEditModal={handleCloseEditModal}
                goalId={original.id}
              />
            </Modal.Body>
          </Modal>

          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this record?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button
                variant="primary"
                onClick={() => deleteReacod(original.id)}
              >
                Yes delete
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        style: { position: 'relative', overflow: 'visible' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

interface GoalsTableProps {
  onShowProgress: (goalId: number) => void;
}

const GoalsTable = ({ onShowProgress }: GoalsTableProps) => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        headerClassName="text-lowercase"
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" showViewAllBtn={false} />
    </div>
  );
};

export default GoalsTable;
